import Localize from './localize.jsx';

export default Localize;
